<template>
    <LayoutDashboard title="Logs">
        <LogFilter />
        <LogItem
            v-show="getLogs.data.length > 0"
            v-for="log in getLogs.data"
            :key="log.id"
            :log="log"
        />
        <LogEmpty v-show="getLogs.data.length === 0" />
        <LogPagination />
    </LayoutDashboard>
</template>

<script>
import LogFilter from './LogFilter.vue'
import LogItem from './LogItem.vue'
import LogPagination from './LogPagination.vue'
import LogEmpty from './Empty.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        LogFilter,
        LogItem,
        LogPagination,
        LogEmpty
    },
    computed: {
        ...mapGetters([
            'getLogs'
        ])
    },
    methods: {
        ...mapActions([
            'listarLogs'
        ])
    },
    created() {
        this.listarLogs()
    }
}
</script>